// Mutation hook - upsert skrzynki mailowej zalogowanego handlowca
// PUT /api/ui/sales-crm/mailbox/my-mailbox
// Konwencja PATCH-style: puste pola hasel = NIE nadpisuj zapisanych wartosci.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IPutMyMailboxRequest,
  IPutMyMailboxResponse
} from 'api/types/mailbox';
import { getMyMailboxQueryKey } from 'api/endpoints/useGetMyMailbox';

const putMyMailbox = (body: IPutMyMailboxRequest): Promise<IPutMyMailboxResponse> =>
  axios.put('/sales-crm/mailbox/my-mailbox', body);

export const usePutMyMailbox = (
  options?: UseMutationOptions<IPutMyMailboxResponse, IError, IPutMyMailboxRequest>
) => {
  const queryClient = useQueryClient();
  return useMutation<IPutMyMailboxResponse, IError, IPutMyMailboxRequest>(putMyMailbox, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(getMyMailboxQueryKey);
      options?.onSuccess?.(data, variables, context);
    }
  });
};
